module.exports = __webpack_public_path__ + "static/media/bg1.66d99f24.jpg";